import { HelpCircle, ArrowRight, Lightbulb } from "lucide-react";
import { useTranslation } from "@/i18n";

const Education = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="glow-orb glow-orb-primary w-[400px] h-[400px] top-0 right-0 opacity-15" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="max-w-3xl mx-auto">
          <div className="p-5 md:p-10 rounded-2xl glass-card gradient-border">
            {/* Question header */}
            <div className="flex items-start gap-4 mb-8">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary/20 to-accent/20 flex items-center justify-center flex-shrink-0">
                <HelpCircle className="w-7 h-7 text-primary" />
              </div>
              <div className="pt-2">
                <h2 className="text-2xl font-bold text-foreground">
                  {t('education.question')}
                </h2>
              </div>
            </div>

            {/* Answer */}
            <div className="md:pl-[4.5rem]">
              <p className="text-xl font-semibold text-foreground mb-6">
                {t('education.answer')}
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3 p-4 rounded-xl glass-card">
                  <ArrowRight className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <p className="text-muted-foreground">
                    {t('education.point1')}
                  </p>
                </div>
                <div className="flex items-start gap-3 p-4 rounded-xl glass-card">
                  <ArrowRight className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <p className="text-muted-foreground">
                    {t('education.point2')}
                  </p>
                </div>
              </div>

              {/* Analogy */}
              <div className="p-5 rounded-xl bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/20">
                <div className="flex items-start gap-3">
                  <Lightbulb className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" />
                  <p className="text-foreground">
                    {t('education.analogy')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
